export enum MeasurementDataFilter {
    // First Amplitude
    FirstAmplitudeNotAvailable = 0,
    FirstAmplitude0To5 = 1,
    FirstAmplitude5To8 = 2,
    FirstAmplitude8Plus = 3,

    // Last Amplitude
    LastAmplitudeNotAvailable = 4,
    LastAmplitude0To5 = 5,
    LastAmplitude5To8 = 6,
    LastAmplitude8Plus = 7,

    // First Result
    FirstResultTofc = 8,
    FirstResultST = 9,
    FirstResult0To40 = 10,
    FirstResult40To80 = 11,
    FirstResult80To90 = 12,
    FirstResult90Plus = 13,

    // Last Result
    LastResultTofc = 14,
    LastResultST = 15,
    LastResultPTC = 16,
    LastResult0To40 = 17,
    LastResult40To80 = 18,
    LastResult80To90 = 19,
    LastResult90Plus = 20,
    // PTC Use
    PtcUseYes = 21,
    PtcUseNo = 22
}
